"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }/* What the composer does with a template once it is inserted: which parts of
 * the draft are chips, where Tab goes, and when Send stays off. Shared by the
 * web and mobile composers. */

var _templateRenderer = require('./templateRenderer');
var _templateResolver = require('./templateResolver');












const listTokens = (texts) =>
  texts.length <= 1 ? texts.join('') : `${texts.slice(0, -1).join(', ')} and ${texts[texts.length - 1]}`

/* Rule A10: once a template has been inserted into this draft, Send (and Send
 * later) stays off while any {{…}} token remains in it, valid or not, or a
 * stray "{{". Typing over or deleting the chip clears it. A draft that never
 * had a template inserted is never blocked here, so typed braces still send. */
 const templateSendBlock = (draft, fromTemplate) => {
  if (!fromTemplate) return { blocked: false }
  const remaining = [...new Set(_templateRenderer.templateTokens.call(void 0, draft).map(t => t.text))]
  if (remaining.length > 0) return { blocked: true, reason: `Fill in ${listTokens(remaining)} before sending` }
  // A chip with a brace deleted ("{{date}") is no longer a token; still hold it.
  if (draft.includes('{{')) return { blocked: true, reason: 'Finish or remove the {{ before sending' }
  return { blocked: false }
}; exports.templateSendBlock = templateSendBlock

/* Every token in the draft, drawn as a chip. */
 const chipRanges = (draft) =>
  _templateRenderer.templateTokens.call(void 0, draft).map(t => ({ start: t.index, end: t.index + t.text.length })); exports.chipRanges = chipRanges

/* The chip Tab (direction 1) or Shift-Tab (-1) selects from the caret,
 * wrapping around; null when there are no chips, so Tab moves focus as usual.
 * A selected chip (caret at its start, selectionEnd at its end) moves on. */
 const nextChip = (draft, caret, direction, selectionEnd = caret) => {
  const chips = exports.chipRanges.call(void 0, draft)
  if (chips.length === 0) return null
  if (direction === 1) {
    const after = selectionEnd > caret ? selectionEnd : caret
    return _nullishCoalesce(chips.find(c => c.start >= after && !(c.start === caret && c.end === selectionEnd)), () => ( chips[0]))
  }
  return _nullishCoalesce([...chips].reverse().find(c => c.end <= caret), () => ( chips[chips.length - 1]))
}; exports.nextChip = nextChip

/* A chip as the composer draws it; `flash` briefly highlights it, as when
 * Enter or Send jumps to a value still to fill. */











 const templateFillState = (draft, fromTemplate) => {
  if (!fromTemplate) return { kind: 'done' }
  const chips = exports.chipRanges.call(void 0, draft)
  if (chips.length > 0) {
    return { kind: 'fill', left: new Set(chips.map(c => draft.slice(c.start, c.end))).size, first: chips[0] }
  }
  const stray = draft.indexOf('{{')
  return stray < 0 ? { kind: 'done' } : { kind: 'stray', at: { start: stray, end: stray + 2 } }
}; exports.templateFillState = templateFillState

/* The bar above the field while something is left: "2 to fill · Next ›",
 * or "Fix the {{ in your message · Go to it ›". Null when nothing is. */
 const fillBarText = (state) => {
  if (state.kind === 'fill') return { text: `${state.left} to fill`, action: 'Next ›', label: 'Next value to fill' }
  if (state.kind === 'stray') return { text: 'Fix the {{ in your message', action: 'Go to it ›', label: 'Go to the {{ to fix' }
  return null
}; exports.fillBarText = fillBarText

/* Where Next (or a blocked Enter or Send) moves the cursor: the next value to
 * fill from the selection, or the stray "{{". */
 const nextToFill = (draft, fromTemplate, selection) => {
  const state = exports.templateFillState.call(void 0, draft, fromTemplate)
  if (state.kind === 'fill') return exports.nextChip.call(void 0, draft, selection.start, 1, selection.end)
  if (state.kind === 'stray') return state.at
  return null
}; exports.nextToFill = nextToFill











/* The templates a chat's picker offers: my private ones, the org's, and team
 * ones for every team I'm on. An org admin (whose list from the server holds
 * every team's) also gets the chat's own teams'. A team template I share with
 * a team I'm on must show for me, admin or not. */
 const usableTemplates = (
  templates,
  myTeamKeys,
  isAdmin,
  chatTeamKeys,
) => {
  const teamKeys = new Set(isAdmin ? [...myTeamKeys, ...chatTeamKeys] : myTeamKeys)
  return templates.filter(t => t.Scope !== 'team' || (!!t.TeamKey && teamKeys.has(t.TeamKey)))
}; exports.usableTemplates = usableTemplates

/* The picker's rows for a query: name or text contains it (any case, a
 * leading "/" ignored), name matches first, then the server's name order. */
 const pickerRows = (
  templates,
  query,
  values,
  teamNames,
  defaults = {},
) => {
  const q = query.replace(/^\//, '').trim().toLowerCase()
  const inName = (t) => t.Name.toLowerCase().includes(q)
  const matches = q ? templates.filter(t => inName(t) || t.Body.toLowerCase().includes(q)) : templates
  const ordered = q ? [...matches.filter(inName), ...matches.filter(t => !inName(t))] : matches
  return ordered.map(template => ({
    template,
    scopeLabel: template.Scope === 'org' ? 'Org'
      : template.Scope === 'team' ? _nullishCoalesce(teamNames[_nullishCoalesce(template.TeamKey, () => ( ''))], () => ( 'Team'))
        : 'Mine',
    missing: _templateResolver.resolveTemplate.call(void 0, template.Body, values, defaults).missing.length,
    preview: _templateResolver.previewTemplate.call(void 0, template.Body, values, defaults),
  }))
}; exports.pickerRows = pickerRows
